'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext } from 'react';
import type { User } from '@openclassrooms/sdk-web';
import { CurrentUserContextValue, type CurrentUserContextProviderProps } from './CurrentUserContext';
import { clearCachedCurrentUser } from '../services/cachedCurrentUser';
const CurrentUserContext = createContext<CurrentUserContextValue | null>(null);
function isConnected(user?: User): user is User {
  return Boolean(user?.id);
}
export const CurrentUserContextProvider = t0 => {
  const $ = _c(5);
  const {
    children,
    user
  } = t0;
  let t1;
  if ($[0] !== user) {
    t1 = {
      refetch() {
        console.error("refetch is not implemented in Nextjs");
      },
      clear() {
        return clearCachedCurrentUser();
      },
      isPending: false,
      expiryTime: Infinity,
      ...(isConnected(user) ? {
        isConnected: true,
        userId: user.id,
        currentUser: user
      } : {
        currentUser: null,
        isConnected: false,
        userId: null
      })
    };
    $[0] = user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contextValue = t1;
  let t2;
  if ($[2] !== children || $[3] !== contextValue) {
    t2 = <CurrentUserContext.Provider value={contextValue}>{children}</CurrentUserContext.Provider>;
    $[2] = children;
    $[3] = contextValue;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const useCurrentUserContext = () => {
  const $ = _c(2);
  const context = useContext(CurrentUserContext);
  if (!context) {
    throw new Error("useCurrentUserContext must be used as a child of CurrentUserContextProvider");
  }
  let t0;
  if ($[0] !== context) {
    t0 = {
      ...context
    };
    $[0] = context;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};